import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';
import { validatePrice } from '@/utils/category';
import { useLocale } from 'next-intl';

const Pricing = ({ price }) => {
  const prices = validatePrice(price);
  const locale = useLocale();
  return (
    <div className='flex items-center justify-between'>
      <div>
        {/* Display current price */}
        <p className='text-primary flex items-center gap-1 text-2xl leading-[28px] font-semibold max-lg:font-bold max-md:text-lg max-sm:text-base'>
          {handlePriceByComma(prices?.final_price || prices?.originalPrice)}{' '}
          <CurrencyIcon className='size-4 max-sm:size-3' />
        </p>

        {/* Show original price with strike-through only if there's a discount */}
        {prices.originalPrice !== prices.final_price &&
          prices.final_price && (
            <p className='flex items-center gap-1 text-xl leading-[18px] text-gray-500 line-through max-lg:text-lg max-md:text-base max-sm:text-xs'>
              {handlePriceByComma(prices.originalPrice)}{' '}
              <CurrencyIcon className='size-4 max-sm:size-3' />
            </p>
          )}
      </div>

      {/* Show discount details if applicable */}
      {prices.originalPrice !== prices.final_price &&
        prices.final_price && (
          <div className='flex flex-col gap-1'>
            <span className='mx-auto flex w-fit items-center gap-1 rounded-lg bg-green-600 px-3 text-xs leading-[28px] text-white max-sm:text-[10px]'>
              {locale === 'en' ? 'SAVE' : 'وفر'}
              {handlePriceByComma(
                +prices.final_price - +prices.originalPrice
              )}{' '}
              <CurrencyIcon className='size-3.5 max-sm:size-2.5' />
            </span>
            <span className='bg-primary mx-auto w-fit rounded-lg px-3 text-xs leading-[28px] text-white max-sm:text-[10px]'>
              {handlePriceByComma(
                ((+prices.final_price - +prices.originalPrice) /
                  prices.originalPrice) *
                  100
              )}
              % {locale === 'en' ? 'OFF' : 'خصم'}
            </span>
          </div>
        )}
    </div>
  );
};

export default Pricing;
